module.exports = __webpack_public_path__ + "media/images/sp/stores/sapporo/sapporo_concept_02-ed906aaf0931813570fce63390aebaae.jpg";